// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BigTitleBlock{align-items:center;background-color:#7cb342;color:#fff;display:flex;flex-direction:column;justify-content:center;padding:.75rem 1rem .5rem;text-align:center}.BigTitleBlock .Wysiwyg .Title{color:inherit;font-size:1.6rem;font-weight:700;max-width:none;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
